import { render, staticRenderFns } from "./BizBusinessinfoCompleteForm.vue?vue&type=template&id=0397a86a&"
import script from "./BizBusinessinfoCompleteForm.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoCompleteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports